import { ReduxPageType } from '@common-types/ReduxPage';
import { Stack } from '@common/components/Stack';
import { TranslationKey, useTranslations } from '@lang';
import { entitySelectors } from '@store/entity/selectors';
import { some } from '@utils/some';
import { connect } from 'react-redux';
import { Link } from 'shared-routing';
import { mapModules } from '../BasketDrawer.helpers';
import { ItemText, StyledImg, StyledRecommendationButton } from '../BasketDrawer.styles';
import {
  RecommendationBox,
  RecommendationsContainer,
  TextAndButtonBox,
} from './Recommendations.styles';

type ReduxProps = {
  spaPage: ReduxPageType;
  tablesPage: ReduxPageType;
  roomsPage: ReduxPageType;
};

type ReccomendationsProps = {
  modules: string[];
};

const RecommendationsList = ({
  modules,
  spaPage,
  tablesPage,
  roomsPage,
}: ReccomendationsProps & ReduxProps) => {
  const { t } = useTranslations();

  const mappedModules = mapModules(modules, { spaPage, tablesPage, roomsPage });

  return (
    <RecommendationBox>
      <Stack gap={2} justifyContent="flex-start">
        {some(mappedModules)
          ? mappedModules.map((module) => (
              <RecommendationsContainer key={module?.id}>
                {module?.heroBackgroundImage && (
                  <StyledImg height={100} width={100} src={module.heroBackgroundImage.url} />
                )}
                <TextAndButtonBox>
                  <ItemText>
                    {t('basketDrawer.recommendations.add')}{' '}
                    {t(`basketDrawer.${module?.slug}` as TranslationKey) ??
                      t('basketDrawer.recommendations.fallback')}{' '}
                    {t('basketDrawer.recommendations.text')}
                  </ItemText>
                  <Link route={module?.route ?? ''}>
                    <StyledRecommendationButton isPrimary isNarrow isSmall>
                      {t('basketDrawer.recommendations.add')}
                    </StyledRecommendationButton>
                  </Link>
                </TextAndButtonBox>
              </RecommendationsContainer>
            ))
          : null}
      </Stack>
    </RecommendationBox>
  );
};

const mapStateToProps = (state) => ({
  spaPage: entitySelectors.getSpaPage(state),
  tablesPage: entitySelectors.getTablesPage(state),
  roomsPage: entitySelectors.getPage(state, 'rooms'),
});

export const Recommendations = connect(mapStateToProps)(RecommendationsList);
